function pushSave() {
    const {canPushProduct, canSaveMap, pushSave, saveMap} = this.commands
    const nodes = canPushProduct([this.root])

    if (0 < nodes.length) {
        pushSave()
    }
    else if (canSaveMap()) {
        saveMap()
    }
}

export default () => ({
    'Ctrl+S': pushSave,
    'Meta+S': pushSave,
})
